<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('productHistory.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('productHistory.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <div class="ts-flex ts-justify-between ts-space-x-3">
            <a-select
              v-model="model.product_list_id"
              mode="multiple"
              :options="productList"
              class="ts-w-full"
              :placeholder="$t('Search:product name|barcode')"
              showSearch
              @search="onProductSearch"
              @change="fetchData()"
              :default-active-first-option="false"
              :show-arrow="false"
              :filter-option="false"
              :not-found-content="null"
              :loading="on_search_product"
            >
            </a-select>
            <div>
              <ts-button
                color="info"
                outline
                :waiting="exporting"
                @click="onExportExcel"
              >
                Excel <i class="fas fa-file-excel"></i>
              </ts-button>
            </div>
          </div>
          <br />
          <div class="max-h">
            <table class="ts-w-full ts-mt-4">
              <thead>
                <th
                  class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap"
                  style="width:200px"
                >
                  {{ $t('productHistory.barcode') }}
                </th>
                <!-- <th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap" style="width:300px" >{{$t('productHistory.productName') }}</th> -->
                <th
                  class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap"
                  style="width:200px"
                >
                  {{ $t('productHistory.tranDate') }}
                </th>
                <th
                  class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap"
                  style="width:200px"
                >
                  {{ $t('productHistory.tranNumber') }}
                </th>
                <th
                  class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap"
                  style="width:200px"
                >
                  {{ $t('productHistory.tranType') }}
                </th>
                <th
                  class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap"
                  style="width:300px"
                >
                  {{ $t('productHistory.locationName') }}
                </th>
                <th
                  class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap"
                  style="width:300px"
                >
                  {{ $t('productHistory.toLocationName') }}
                </th>
                <th
                  class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap"
                  style="width:100px"
                >
                  {{ $t('productHistory.quantity') }}
                </th>
                <!-- <th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap" style="width:100px">{{$t('productHistory.multiplier') }}</th> -->
                <th
                  class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap"
                  style="width:200px"
                >
                  {{ $t('productHistory.createdDate') }}
                </th>
                <th
                  class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap"
                  style="width:200px"
                >
                  {{ $t('productHistory.projectName') }}
                </th>
              </thead>
              <tbody>
                <template v-for="(resource, index) in groupResources">
                  <tr :key="index">
                    <td colspan="10" class="ts-bg-blue-100 ts-px-2 ts-py-2">
                      <p class="ts-font-semibold ts-mb-0 ts-text-black">
                        {{ index }}
                      </p>
                    </td>
                  </tr>
                  <tr
                    v-for="item in resource"
                    :key="item.product_id"
                    class="hover:ts-bg-gray-200 hover:ts-text-red-600 hover:ts-font-semibold ts-cursor-default"
                  >
                    <td class="ts-py-1 ts-pl-4">{{ item.barcode }}</td>
                    <td class="ts-py-1 ts-px-2 ts-text-left">
                      {{ item.trans_date }}
                    </td>
                    <td class="ts-py-1 ts-px-2">{{ item.trans_number }}</td>
                    <td class="ts-py-1 ts-px-2">{{ item.trans_type }}</td>
                    <td class="ts-py-1 ts-px-2">{{ item.location_name }}</td>
                    <td class="ts-py-1 ts-px-2">{{ item.to_location }}</td>
                    <td
                      class="ts-py-1 ts-px-2 ts-text-center"
                      :class="
                        item.multiplier > 0
                          ? 'ts-text-green-600 ts-font-extrabold'
                          : 'ts-text-red-600'
                      "
                    >
                      {{
                        (item.multiplier > 0 ? '+' : '-') +
                          item.quantity * item.multiplier
                      }}
                    </td>
                    <!-- <td class="ts-py-1 ts-px-2 ts-text-center">{{ item.multiplier }}</td> -->
                    <td class="ts-py-1 ts-px-2">{{ item.created_date }}</td>
                    <td class="ts-py-1 ts-px-2">{{ item.project_name }}</td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
          <div class="d-flex justify-content-end p-15">
            <ts-pagination
              v-model="pagination"
              @navigate="fetchData"
            ></ts-pagination>
          </div>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { groupBy, trim } from 'lodash'
import * as FileDownload from 'downloadjs'

export default {
  name: 'productHistory',
  data() {
    return {
      loading: false,
      on_search_product: false,
      exporting: false,
      products: [],
      model: {
        product_list_id: []
      }
    }
  },
  computed: {
    ...mapState('product/history', ['resources', 'pagination']),
    groupResources() {
      return groupBy(this.resources, 'product_name')
    },
    productList() {
      return this.products.map(product => ({
        value: product.product_id,
        label: product.product_name_en
      }))
    }
  },
  methods: {
    ...mapActions('product/history', [
      'listView',
      'getProductProfile',
      'exportToExcel'
    ]),
    fetchData(attributes = {}) {
      this.loading = true
      this.listView(Object.assign(this.model, attributes))
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onProductSearch: _.debounce(function(value) {
      this.on_search_product = true
      this.getProductProfile({
        search: value
      })
        .then(response => {
          this.products = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.on_search_product = false
        })
    }, 1000),
    onExportExcel() {
      this.exporting = true
      this.exportToExcel(this.model)
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          // this.errors = new Errors(error.errors)
        })
        .finally(() => (this.exporting = false))
    }
  }
}
</script>

<style scoped>
.max-h {
  height: 70vh;
  max-height: 75vh;
  overflow: scroll;
}
table {
  /* white-space: nowrap; */
  margin: 0;
  /* border-collapse: separate; */
  border-spacing: 0;
  /* table-layout: fixed; */
  /* border: 1px solid black; */
}
table thead {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: rgb(22, 102, 145);
  color: white;
}
</style>
